import { defineMessages } from "react-intl";

const messages = defineMessages({
    h1: {
        id: "memory.landing.hero.h1",
    },
    h2: {
        id: "memory.landing.hero.h2",
    },
    start: {
        id: "landing.start",
    },
    carousel1Title: {
        id: "memory.landing.hero.carousel.1.title",
    },
    toClassroomEducation: {
        id: "memory.landing.hero.toClassroomEducation",
    },
});

export default messages;
